(function(){
if(window.WsPage)return;
var money=function(c){return '$'+Math.round(c/100).toLocaleString('es-CL')};
function initBuy(root){
 root.querySelectorAll('[data-ws-buy]:not([data-ok])').forEach(function(sec){
  sec.setAttribute('data-ok','1');
  var vs=[];try{vs=JSON.parse(sec.querySelector('[data-ws-variants]').textContent)}catch(e){}
  var idIn=sec.querySelector('[data-ws-id]'),planIn=sec.querySelector('[data-ws-plan]'),sel=sec.querySelector('[data-ws-plan-select]');
  var btn=sec.querySelector('[data-ws-add]'),cur=vs.find(function(v){return String(v.id)===idIn.value})||vs[0];
  var mode=sec.querySelector('[data-ws-opt="sub"]')?'sub':'once';
  function paint(){
   if(!cur)return;
   idIn.value=cur.id;
   sec.querySelectorAll('[data-ws-pack]').forEach(function(b){b.classList.toggle('is-on',b.dataset.wsPack==String(cur.id))});
   var plan=sel?sel.value:'';var subP=plan&&cur.plans[plan]!=null?cur.plans[plan]:null;
   var set=function(q,t){sec.querySelectorAll(q).forEach(function(e){e.textContent=t})};
   set('[data-ws-once-price]',money(cur.price));
   set('[data-ws-compare]',cur.compare>cur.price?money(cur.compare):'');
   set('[data-ws-sub-price]',subP!=null?money(subP):money(cur.price));
   set('[data-ws-sub-compare]',subP!=null&&subP<cur.price?money(cur.price):'');
   sec.querySelectorAll('[data-ws-opt]').forEach(function(o){var on=o.dataset.wsOpt===mode;o.classList.toggle('is-on',on);var r=o.querySelector('input');if(r)r.checked=on});
   if(planIn){planIn.disabled=mode!=='sub';planIn.value=plan}
   btn.disabled=!cur.available;btn.textContent=cur.available?btn.dataset.label:btn.dataset.soldout;var sb2=sec.querySelector('[data-ws-sticky-add]');if(sb2){sb2.disabled=!cur.available}
  }
  sec.querySelectorAll('[data-ws-pack]').forEach(function(b){b.addEventListener('click',function(){cur=vs.find(function(v){return String(v.id)===b.dataset.wsPack})||cur;paint()})});
  sec.querySelectorAll('[data-ws-opt]').forEach(function(o){o.addEventListener('click',function(){mode=o.dataset.wsOpt;paint()})});
  sel&&sel.addEventListener('change',function(){mode='sub';paint()});
  var q=sec.querySelector('[data-ws-qty]');
  sec.querySelectorAll('[data-ws-step]').forEach(function(b){b.addEventListener('click',function(){q.value=Math.max(1,(+q.value||1)+(+b.dataset.wsStep))})});
  var tr=sec.querySelector('[data-ws-track]');
  if(tr){
   var go=function(d){tr.scrollBy({left:d*tr.clientWidth,behavior:'smooth'})};
   var p=sec.querySelector('[data-ws-prev]'),n=sec.querySelector('[data-ws-next]');p&&p.addEventListener('click',function(){go(-1)});n&&n.addEventListener('click',function(){go(1)});
   var th=sec.querySelectorAll('[data-ws-thumb]');
   th.forEach(function(t,i){t.addEventListener('click',function(){tr.scrollTo({left:i*tr.clientWidth,behavior:'smooth'})})});
   tr.addEventListener('scroll',function(){var i=Math.round(tr.scrollLeft/Math.max(1,tr.clientWidth));th.forEach(function(t,k){t.classList.toggle('is-on',k===i)})},{passive:true});
  }
  var sk=sec.querySelector('[data-ws-sticky]'),form=sec.querySelector('form.ws-form');
  if(sk&&form&&'IntersectionObserver' in window){
   new IntersectionObserver(function(es){var on=!es[0].isIntersecting&&es[0].boundingClientRect.top<0;sk.classList.toggle('is-on',on);sk.setAttribute('aria-hidden',on?'false':'true')}).observe(btn);
   var sb=sk.querySelector('[data-ws-sticky-add]');sb&&sb.addEventListener('click',function(){if(form.requestSubmit)form.requestSubmit();else form.submit()});
  }
  paint();
 });
}
function initBA(root){
 root.querySelectorAll('[data-ws-ba]:not([data-ok])').forEach(function(sec){
  sec.setAttribute('data-ok','1');
  var sl=sec.querySelectorAll('[data-ws-slide]'),i=0,lab=sec.querySelector('[data-ws-count]');
  function show(k){i=(k+sl.length)%sl.length;sl.forEach(function(s,j){s.classList.toggle('is-on',j===i)});if(lab)lab.textContent=(i+1)+' / '+sl.length}
  sec.querySelectorAll('[data-ws-go]').forEach(function(b){b.addEventListener('click',function(){show(i+(+b.dataset.wsGo))})});
  if(sl.length)show(0);
 });
}
function initRev(root){
 root.querySelectorAll('[data-ws-rev]:not([data-ok])').forEach(function(sec){
  sec.setAttribute('data-ok','1');
  var m=sec.querySelector('[data-ws-more]');
  m&&m.addEventListener('click',function(){var h=sec.querySelectorAll('.ws-rv.is-hidden');for(var k=0;k<5&&k<h.length;k++)h[k].classList.remove('is-hidden');if(!sec.querySelector('.ws-rv.is-hidden'))m.style.display='none'});
 });
}
function init(r){initBuy(r);initBA(r);initRev(r)}
window.WsPage={init:init};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});else init(document);
document.addEventListener('shopify:section:load',function(e){init(e.target)});
document.addEventListener('shopify:block:select',function(e){var s=e.target.closest&&e.target.closest('[data-ws-slide]');if(s){var sec=s.closest('[data-ws-ba]');var all=[].slice.call(sec.querySelectorAll('[data-ws-slide]'));all.forEach(function(x){x.classList.toggle('is-on',x===s)})}});
})();
